/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - repair.njk
 *   - repair.css
 */

export const REPAIR_TEMPLATE = `<div class="wrap">
  <div class="hdr">
    <h2>{{ storeName }}</h2>
    {% if address %}<p>{{ address | replace('\\n', '<br/>') | safe }}</p>{% endif %}
    {% if phone %}<p>Tel: {{ phone }}</p>{% endif %}
  </div>

  <div class="dashes"></div>

  <div class="meta">
    <div>
      <p><span class="meta-lbl">Job No:</span> <b>{{ jobNo }}</b></p>
      <p><span class="meta-lbl">Date:</span> {{ dateStr }}</p>
    </div>
    <div style="text-align:right">
      <p><span class="meta-lbl">Customer:</span> {{ customerName }}</p>
      {% if customerPhone %}<p><span class="meta-lbl">Tel:</span> {{ customerPhone }}</p>{% endif %}
    </div>
  </div>

  <div class="dashes"></div>

  <div class="device-section">
    <h4>Device Information</h4>
    <div class="row">
      <span class="meta-lbl">Device:</span>
      <span>{{ deviceLabel }}</span>
    </div>
    {% if imei %}
    <div class="row">
      <span class="meta-lbl">IMEI:</span>
      <span>{{ imei }}</span>
    </div>
    {% endif %}
    {% if serialNumber %}
    <div class="row">
      <span class="meta-lbl">Serial No:</span>
      <span>{{ serialNumber }}</span>
    </div>
    {% endif %}
    {% if promisedDate %}
    <div class="row">
      <span class="meta-lbl">Promised:</span>
      <span>{{ promisedDate }}</span>
    </div>
    {% endif %}
    <div class="row">
      <span class="meta-lbl">Issues:</span>
      <span>{{ reportedIssues }}</span>
    </div>
    {% if diagnosis %}
    <div class="row">
      <span class="meta-lbl">Diagnosis:</span>
      <span>{{ diagnosis }}</span>
    </div>
    {% endif %}
    {% if technicianNotes %}
    <div class="row">
      <span class="meta-lbl">Notes:</span>
      <span>{{ technicianNotes }}</span>
    </div>
    {% endif %}
  </div>

  <div class="dashes"></div>

  {% if items.length > 0 %}
  <div class="parts-section">
    <h4>Parts / Materials Used</h4>
    <table>
      <thead>
        <tr>
          <th align="left">Part Name</th>
          <th align="center">Qty</th>
          <th align="right">Rate</th>
          <th align="right">Total</th>
        </tr>
      </thead>
      <tbody>
        {% for item in items %}
        <tr>
          <td>{{ item.part_name }}</td>
          <td align="center">{{ item.quantity }}</td>
          <td align="right">{{ item.unit_price | formatPrice }}</td>
          <td align="right"><b>{{ item.total_price | formatPrice }}</b></td>
        </tr>
        {% endfor %}
      </tbody>
    </table>
  </div>
  <div class="dashes"></div>
  {% endif %}

  <div class="payment-section">
    <h4>Payment Summary</h4>
    <div class="row">
      <span>Selling Price</span>
      <span>{{ currency }} {{ sellingPrice | formatPrice }}</span>
    </div>
    <div class="row">
      <span>Paid Amount</span>
      <span style="color:#15803d">{{ currency }} {{ paidAmount | formatPrice }}</span>
    </div>
    <div class="row">
      <span>Due Amount</span>
      <span style="color:{{ '#b91c1c' if dueAmount > 0 else '#15803d' }}">{{ currency }} {{ dueAmount | formatPrice }}</span>
    </div>
    {% if payments.length > 0 %}
    <div class="dashes"></div>
    <table class="payment-table">
      <thead>
        <tr>
          <th align="left">Date</th>
          <th align="left">Method/Ref</th>
          <th align="left">Note</th>
          <th align="right">Amount</th>
        </tr>
      </thead>
      <tbody>
        {% for pay in payments %}
        <tr>
          <td valign="top" style="font-size:0.85em;color:#6b7280">{{ (pay.payment_date or pay.created_at) | dateFormat }}</td>
          <td valign="top">{{ pay.payment_method_name or 'N/A' }}{% if pay.transaction_no %} ({{ pay.transaction_no }}){% endif %}</td>
          <td valign="top" style="font-size:0.85em;color:#6b7280">{{ pay.notes or pay.note or '' }}</td>
          <td valign="top" align="right"><b>{{ currency }} {{ pay.amount | formatPrice }}</b></td>
        </tr>
        {% endfor %}
      </tbody>
    </table>
    {% endif %}
  </div>

  <div class="ftr">
    <p>{{ footer }}</p>
    <p style="margin-top:6px;font-size:0.85em">Powered by TaproDev POS</p>
  </div>
</div>
`;

export const REPAIR_CSS = `.wrap {
  width: var(--inv-width);
  margin: var(--inv-body-pad);
  background: #fff;
  padding: var(--inv-pad);
  box-shadow: var(--inv-shadow);
  border-radius: var(--inv-radius);
  box-sizing: border-box;
  font-family: 'Courier New', Courier, monospace;
  font-size: var(--inv-font);
  line-height: 1.4;
  color: #000;
}

.hdr {
  text-align: center;
  margin-bottom: 12px;
}

.hdr h2 {
  margin: 0 0 4px 0;
  font-size: var(--inv-h2-size);
  font-weight: 800;
  text-transform: uppercase;
}

.hdr p {
  margin: 2px 0;
  font-size: var(--inv-p-size);
  color: #444;
}

.meta {
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
  font-size: 0.95em;
}

.meta p {
  margin: 2px 0;
}

.meta-lbl {
  color: #666;
  font-weight: bold;
}

.device-section, .parts-section, .payment-section {
  margin: 10px 0;
}

.device-section h4, .parts-section h4, .payment-section h4 {
  margin: 0 0 6px 0;
  font-size: 1.05em;
  font-weight: bold;
  text-transform: uppercase;
  border-bottom: 1px solid #000;
  padding-bottom: 2px;
}

.row {
  display: flex;
  justify-content: space-between;
  margin: 4px 0;
}

.dashes {
  border-top: 1px dashed #000;
  margin: 8px 0;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 6px 0;
  font-size: 0.95em;
}

th {
  border-bottom: 1px solid #000;
  padding: var(--inv-th-pad);
  font-weight: bold;
}

td {
  padding: var(--inv-td-pad);
  vertical-align: top;
}

.ftr {
  text-align: center;
  margin-top: var(--inv-ftr-mt);
  font-size: var(--inv-ftr-size);
  color: #555;
}

.ftr p {
  margin: 2px 0;
}
`;
